module.exports = __webpack_public_path__ + "img/frente-de-centro.e2cba277.png";